// Session storage keys
export const ORIGIN_SESSION_STORAGE_KEY = 'origin';
export const STRATEGY_SESSION_STORAGE_KEY = 'strategy';
export const CLIENT_ID_SESSION_STORAGE_KEY = 'clientid';
export const D2D_TOKEN_SESSION_STORAGE_KEY = 'd2dToken';
export const AUTH_TOKEN_SESSION_STORAGE_KEY = 'authToken';
export const SESSION_ID_SESSION_STORAGE_KEY = 'sessionId';
export const EXCL_ACCOUNT_SESSION_STORAGE_KEY = 'excl';
export const LANGUAGE_SESSION_STORAGE_KEY = 'lang';
export const SITE_CODE_SESSION_STORAGE_KEY = 'siteCode';
